import { z } from 'zod';

export const MediaFormatSchema = z.enum(['square','portrait','landscape']);

export type MediaFormatType = `${z.infer<typeof MediaFormatSchema>}`

export default MediaFormatSchema;
